<template>
  <div class="page">
    <iframe
      :src="`${url}/bi-link/EmbeddedDossier.html?token=${token}&url=${url}`"
      title="control-panel-iframe"
      style="width: 100%; height: 100%"
    />
  </div>
</template>
<script>
import { BASE_URL } from '@/api/api'
export default {
    name: 'ControlPanelIndex',
    computed: {
        token() {
            return sessionStorage.token
        },
        url() {
            return BASE_URL
        }
    }
}
</script>
<style lang="scss">

</style>
